import { ReferenceProps, TechProps } from '../../types/portfolio';
import KnowledgeItem from '../knowledge-item';
import DisplayLogo from '../display-logo';
import { kebabCase } from '../../scripts/string-manipulators';
import classes from '../../styles/portfolio.module.css';
import { useEffect, useState } from 'react';

type ContentProps = {
  articleName: string,
  description: Array<string>,
  exampleAlt?: string | null,
  exampleUrl?: string | null,
  intro?: string,
  knowledge: any,
  logo: string | null,
  quote?: string,
  references?: any,
  role?: string,
}

const Content = ({
  articleName,
  description,
  exampleAlt,
  exampleUrl,
  intro,
  knowledge,
  logo,
  quote,
  references,
  role,
}: ContentProps) => {
  const [docWidth, setDocWidth] = useState(document.documentElement.getBoundingClientRect().width);

  useEffect(() => {
    const updateRect = () => {
      setDocWidth(document.documentElement.getBoundingClientRect().width);
    }

    window.addEventListener('resize', updateRect);

    return () => {
      window.removeEventListener('resize', updateRect);
    }
  }, []);

  return (
    <div className={classes.content}>
      <div className={classes.intro}>
        <div>
          {logo && docWidth < 768 && (
            <div className={classes.logo}>
              <DisplayLogo logoName={logo} />
            </div>
          )}

          {quote && (
            <p className={classes.byLine}>
              &lsquo;{quote}&rsquo;
            </p>
          )}

          {intro && (
            <p className={classes.introText}>
              {intro}
            </p>
          )}

          {exampleUrl && exampleAlt && docWidth < 768 && (
            <img src={exampleUrl} width="100%" alt={exampleAlt} />
          )}

          {role && (
            <h3 className={classes.h3}>
              {role}
            </h3>
          )}

          {description.map((para: string, index: number) => (
            <p key={`para_${index}`}>
              {para}
            </p>
          ))}

          <div className={classes.knowledge}>
            {knowledge.map((tech: TechProps) => (
              <KnowledgeItem
                keyId={articleName}
                tech={tech}
              />
            ))}
          </div>
        </div>

        {docWidth >= 768 && (
          <div className={classes.byLineCover}>
            {logo && (
              <div className={classes.logo}>
                <DisplayLogo logoName={logo} />
              </div>
            )}

            {exampleUrl && exampleAlt && (
              <img src={exampleUrl} width="300" alt={exampleAlt} />
            )}
          </div>
        )}
      </div>

      {references && (
        <>
          <h3 className={classes.h3}>
            References:
          </h3>
          <ul className={classes.references}>
            {references.map((reference: ReferenceProps) => (
              <li key={kebabCase(reference.name)}>
                <a
                  href={reference.url}
                  rel="noreferrer"
                  target="_blank"
                >
                  {reference.name}
                </a>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default Content;
